import {Button, Divider, Row, Typography, theme} from 'antd'
import React from 'react'
import {useCurrentUser} from '../../hooks/useCurrentUser'
import './home.less'
import {useNavigate, useNavigation, useRouteLoaderData} from 'react-router-dom'
import {News} from '../../entities/news'
import {useIntl} from 'react-intl'
import {ProjectPanel} from '../project/ProjectPanel'
import {ProjectInfoStatistics} from '../../entities/project'
import {NewsList} from './NewsList'
import iconPortal from 'url:../../../public/assets/images/iconPortal2.svg'
import {Link} from 'react-router-dom'
const {Title} = Typography
import {ArrowDownOutlined, CheckOutlined, RightOutlined} from '@ant-design/icons'

export function Home() {
  const {newsList, projectStatistics, plantedPlantsNamesWithId} = useRouteLoaderData('home') as {
    newsList: News[]
    projectStatistics: ProjectInfoStatistics
    plantedPlantsNamesWithId: {id: number; name: string}[]
  }

  const user = useCurrentUser()

  const intl = useIntl()

  const newsListNews = newsList?.filter((n) => n.newsType === 'news') || []
  const newsListTutorials = newsList?.filter((n) => n.newsType === 'tutorials') || []

  const {
    token: {controlHeightSM},
  } = theme.useToken()

  if (!user) {
    return null
  }

  const navigation = useNavigation()
  const navigate = useNavigate()

  return (
    <div className="home-layout__content">
      <div className="home-layout__title home-layout__project-overview">
        <h2>{intl.formatMessage({id: 'projectOverview'})}</h2>
        <div className="home-top__title__buttons">
          <Link className="home-top__link" to="/projects">
            <Button className="home-top__button home-top__action-button">
              <ArrowDownOutlined className="home-top__button__icon-add-plant" />
              {intl.formatMessage({id: 'addPlant'})}
            </Button>
          </Link>
          <Link className="home-top__link" to="/projects">
            <Button className="home-top__button home-top__action-button">
              <CheckOutlined className="home-top__button__icon-add-task" />
              {intl.formatMessage({id: 'addTask'})}
            </Button>
          </Link>
          <Link className="home-top__link" to="/projects">
            <Button className="home-top__button">
              {intl.formatMessage({id: 'allProjects'})}
              <RightOutlined />
            </Button>
          </Link>
        </div>
      </div>
      <div className="home-top">
        {projectStatistics && (
          <>
            <ProjectPanel
              projectStatistics={projectStatistics}
              plantedPlantsNamesWithId={plantedPlantsNamesWithId}
            />
            {/* <Link className="home-top__link" to="/projects">
              <Button className="home-top__button">
                {intl.formatMessage({id: 'allProjects'})}
              </Button>
            </Link> */}
          </>
        )}
        {!projectStatistics && (
          <>
            <div className="home-top__first-project-list">
              {[
                intl.formatMessage({id: 'createYourFirstProjectDescription1'}),
                intl.formatMessage({id: 'createYourFirstProjectDescription2'}),
                intl.formatMessage({id: 'createYourFirstProjectDescription4'}),
              ].map((text, index) => (
                <div className="planner__list__item" key={index}>
                  <img src={iconPortal}></img>
                  <span>{text}</span>
                </div>
              ))}
            </div>
            <Link className="home-top__first-project-link" to="/projects/new">
              <Button className="home-top__first-project-button">
                {intl.formatMessage({id: 'createFirstProject'})}
              </Button>
            </Link>
          </>
        )}
      </div>

      <div className="home-layout__materials">
        <div className="home-layout__title">
          <h2>{intl.formatMessage({id: 'usefulMaterials'})}</h2>
          <Link className="home-top__link" to="/home/news">
            <Button className="home-top__button">
              {intl.formatMessage({id: 'allUsefulMaterials'})}
              <RightOutlined />
            </Button>
          </Link>
        </div>
        {newsListTutorials.length != 0 && (
          <NewsList newsList={newsListTutorials} type="tutorials" />
        )}
      </div>

      <div className="home-layout__news">
        <div className="home-layout__title">
          <h2>{intl.formatMessage({id: 'news'})}</h2>
          <Link className="home-top__link" to="/home/news">
            <Button className="home-top__button">
              {intl.formatMessage({id: 'allNews'})}
              <RightOutlined />
            </Button>
          </Link>
        </div>

        {newsListNews.length != 0 && <NewsList newsList={newsListNews} type="news" />}
      </div>
    </div>
  )
}
